<template>
  <div
    ref="imageEditModal"
    class="modal modal-v modal-v--mobile-fullscreen fade"
    id="imageEditModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="imageEditModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-edit-image" role="document">
      <div v-if="media" class="modal-content">
        <ModalNavMobile></ModalNavMobile>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body text-center modal-edit-image__body">
          <form @submit.prevent="updateMedia" class="mt-3" id="form-edit" method="post">
            <div class="modal-edit-image__checkbox-avatar">
              <label>
                <div class="js-image-preview modal-edit-image__image" v-bind:style="{ 'background-image': 'url(' + media.url + ')' }">
                  <!--                   <input v-model="form.avatar" id="avatar" type="checkbox" name="avatar" />-->
                  <input id="avatar" type="checkbox" name="avatar" />

                  <div v-if="canEdit" class="set-avatar-button" @click="setAsAvatar">
                    <span class="set-avatar-button__label">{{ trans.get('profile:edit.set_as_profile_photo') }}</span>
                    <span class="box js-editable"></span>
                  </div>
                </div>
              </label>
            </div>
            <div v-if="canEdit" class="modal-edit-image__box-price mt-3 js-editable">
              <div class="checkbox-standard pull-left">
                <label>
                  <input v-model="form.paid" id="paid" name="paid" type="checkbox" class="form-control mr-2" value="1" />

                  <span class="checkbox-standard__box mr-2"></span> {{ trans.get('profile:edit.edit_image_modal.paid_photo') }}
                </label>
              </div>
              <div id="price-input" class="form-inline modal-edit-image__set-price">
                <input
                  v-model="form.price"
                  id="price"
                  name="price"
                  type="number"
                  class="input-number input-number__underline"
                  min="1"
                  max="200"
                  value="1"
                  :disabled="!form.paid"
                />
              </div>
            </div>
            <button v-if="canEdit" type="submit" class="button button__fill mt-3 mb-3 js-editable">
              {{ trans.get('profile:edit.edit_image_modal.save_changes_button') }}
            </button>
          </form>
          <form @submit.prevent="deleteMedia" id="form-delete" method="post">
            <button type="submit" class="button button__link button__link--red mt-1 mb-3">
              <i class="demo-icon icon-close pr-1"></i>{{ trans.get('profile:edit.edit_image_modal.remove_image_button') }}
            </button>
          </form>
          <button type="button" class="button button__link button__link--underline mb-3" data-dismiss="modal">
            {{ trans.get('profile:edit.edit_image_modal.close_button') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalNavMobile from '../../../front/components/ModalNavMobile.vue';

export default {
  name: 'EditImageModal',
  components: { ModalNavMobile },
  props: {},
  data() {
    return {
      open: false,
      media: null,
      form: {
        avatar: false,
        price: null,
        paid: false,
      },
      canEdit: true,
    };
  },
  computed: {},
  watch: {
    open(val) {
      if (val) {
        $(this.$refs.imageEditModal).modal('show');
      } else {
        $(this.$refs.imageEditModal).modal('hide');
        this.$eventHub.$emit('FreshGallery');
        this.media = null;
      }
    },
  },
  methods: {
    updateMedia: function (el) {
      let vm = this;

      const form = {
        avatar: this.form.avatar,
        paid: this.form.paid,
      };
      if (this.form.paid) {
        form.price = this.form.price;
      }

      axios
        .put(zRoute('ajax.user.media.update', this.media.id), form)
        .then(function (response) {
          vm.open = false;
        });
    },
    deleteMedia: function (el) {
      let vm = this;

      axios
        .delete(zRoute('ajax.user.media.destroy', this.media.uuid))
        .then(function (response) {
          vm.open = false;
        });
    },
    setAsAvatar: function () {
      axios
        .post(zRoute('ajax.user.media.avatar', this.media.id))
        .then((response) => {
          this.$eventHub.$emit('FreshGallery');
          this.$notify({
            group: 'custom-template',
            type: 'info',
            text: response.data.message,
            duration: 5000,
            data: {},
          });
        });
    },
  },
  mounted() {
    let vm = this;
    this.$eventHub.$on('EditImageModalOpen', (media) => {
      vm.media = media;
      vm.form.avatar = false;
      vm.form.price = media.price ? media.price : 20;
      vm.form.paid = media.price ? true : false;

      vm.canEdit = true;
      if (media.collection_name === 'avatars' || media.verified_at === null) {
        vm.canEdit = false;
      }
      vm.open = true;
    });

    $(this.$refs.imageEditModal).on('hidden.bs.modal', function (e) {
      vm.open = false;
    });
  },
};
</script>

<style scoped></style>
